import React from "react";
import { Button, Menu, MenuButton, MenuList, Tooltip } from "@chakra-ui/react";
import { ActionsMenuItem } from "./ActionsMenuItem";
import { colours } from "@/utils/themeUtils";
import { ChakraFAIcon } from "@/components/ui/Icon";
import { IconVariant } from "@/utils/fontAwesomeUtils";

export type ActionsDropdownItem = {
	icon: string;
	label: string;
	show: boolean;
	disabled: boolean;
	action: () => void;
	tooltip?: string;
	dataTestId?: string;
	iconVariant?: IconVariant;
};

interface Props {
	title: string;
	dataTestId?: string;
	items: ActionsDropdownItem[];
	disabled?: boolean;
	disabledTooltip?: string;
}

export function ActionsMenu(props: Props): JSX.Element {
	const menuButton = (
		<MenuButton
			as={Button}
			title={props.disabled ? undefined : props.title}
			alignItems={"center"}
			py={0}
			px={4}
			rounded={"6px"} // Hack to prevent FZLC Chakra theme in Courses microfrontend from overriding the border radius
			background={"white"}
			color={colours.navy[800]}
			_hover={{
				background: "#F3F5F9",
			}}
			_active={{
				background: "#F3F5F9",
			}}
			_disabled={{
				bg: colours.neutrals[100],
				color: colours.neutrals[300],
				cursor: "not-allowed",
			}}
			isDisabled={props.disabled}
			data-testid={props.dataTestId}
		>
			{props.title}
			<ChakraFAIcon icon="fa-chevron-down" variant="solid" color="#6B778C" boxSize={4} ml={3} />
		</MenuButton>
	);

	return (
		<Menu>
			{props.disabled && props.disabledTooltip ? (
				<Tooltip label={props.disabledTooltip} placement="top" hasArrow shouldWrapChildren>
					<span style={{ display: "inline-block" }}>{menuButton}</span>
				</Tooltip>
			) : (
				menuButton
			)}
			<MenuList minWidth={"170px"} maxWidth={"250px"}>
				{props.items.map(
					(item) =>
						item.show && (
							<ActionsMenuItem
								key={item.label}
								icon={item.icon}
								label={item.label}
								tooltip={item.tooltip}
								onClick={item.action}
								disabled={item.disabled}
								dataTestId={item.dataTestId}
								iconVariant={item.iconVariant}
							/>
						)
				)}
			</MenuList>
		</Menu>
	);
}
